export const chatsPath = () => "/chats";
export const chatPath = (id) => `/chats/${id}`;
